import React from 'react';
import _ from 'lodash';
import FilterCheckbox from '../../../components/FilterCheckbox/FilterCheckbox';
import FilterLabel from '../../../components/FilterLabel/FilterLabel';
import FilterDelimiter from '../../../components/FilterDelimiter/FilterDelimiter';
import phraseTypes from '../../../../const/phraseTypes';
import {
    PHRASE_FILTER,
    PATTERNHASH_FILTER,
    ENTITY_TYPE_FILTER,
    ENTITY_VALUE_FILTER,
    DIALOG_FILTER,
    OUTPUT_PHRASES,
    INPUT_PHRASES,
    UNRECOGNIZED_PHRASES,
} from '../../../../const/logFilters';
import getColorByText from '../../../../services/mini/getColorByText';

class AnalyticIntentsConstantFilters extends React.Component {
    setUnrecognizedPhrasesFilter = (e) => {
        const { setFilter } = this.props;
        setFilter(UNRECOGNIZED_PHRASES, null, e);
    }

    setInputPhrasesFilter = (e) => {
        const { setFilter } = this.props;
        setFilter(INPUT_PHRASES, null, e);
    }

    setOutputPhrasesFilter = (e) => {
        const { setFilter } = this.props;
        setFilter(OUTPUT_PHRASES, null, e);
    }

    render() {
        const {
            environment,
            filters,
            intents,
        } = this.props;

        const inputPhrases = _.filter(intents, (phrase) => {
            const phraseType = phraseTypes[phrase.type.toLowerCase()];
            return phraseType === phraseTypes.input && phrase.notFound !== true;
        });

        const outputPhrases = _.filter(intents, (phrase) => {
            const phraseType = phraseTypes[phrase.type.toLowerCase()];
            return phraseType === phraseTypes.output;
        });

        const unrecognisedPhrases = _.filter(intents, function (phrase) {
            let phraseType;
            if (phrase.type) {
                phraseType = phraseTypes[phrase.type.toLowerCase()];
                if (phraseType === phraseTypes.input || phraseType === phraseTypes.output) {
                    return phrase.notFound === true;
                }
            }
            return true;
        });

        const inputPhrasesCount = inputPhrases.length;
        const outputPhrasesCount = outputPhrases.length;
        const unrecognisedPhrasesCount = unrecognisedPhrases.length;

        return (
            <div className={`analytic-intents-filters ${environment}`}>

                <div className="analytic-intents-filters_constant-filters">
                    {/* <FilterCheckbox
                        type="info"
                        label="Unrecognized"
                        count={unrecognisedPhrasesCount}
                        classes="unrecognised-phrases-ch"
                        onClick={this.setUnrecognizedPhrasesFilter}
                        value={filters[UNRECOGNIZED_PHRASES]} /> */}

                    <FilterCheckbox
                        type="info"
                        label="Input"
                        count={inputPhrasesCount + unrecognisedPhrasesCount}
                        classes="input-phrases-ch"
                        onClick={this.setInputPhrasesFilter}
                        value={filters[INPUT_PHRASES]} />

                    <FilterCheckbox
                        type="info"
                        label="Output"
                        count={outputPhrasesCount}
                        classes="output-phrases-ch"
                        onClick={this.setOutputPhrasesFilter}
                        value={filters[OUTPUT_PHRASES]} />
                </div>
            </div>
        );
    }
}


export default AnalyticIntentsConstantFilters;
